import React from 'react';
import Icon from '../../../components/AppIcon';

const DOC_STATUS = {
  received: { label: 'Received', color: '#60a5fa', bg: 'rgba(96,165,250,0.1)', border: 'rgba(96,165,250,0.25)', icon: 'Inbox' },
  under_review: { label: 'Under Review', color: '#f59e0b', bg: 'rgba(245,158,11,0.1)', border: 'rgba(245,158,11,0.25)', icon: 'Search' },
  verified: { label: 'Verified', color: '#10b981', bg: 'rgba(16,185,129,0.1)', border: 'rgba(16,185,129,0.25)', icon: 'CheckCircle' },
  rejected: { label: 'Rejected', color: '#ef4444', bg: 'rgba(239,68,68,0.1)', border: 'rgba(239,68,68,0.25)', icon: 'XCircle' },
};

const DocumentStatusIndicators = ({ application }) => {
  const appStatus = application?.status || 'pending';

  const getDocStatus = () => {
    if (appStatus === 'approved') return 'verified';
    if (appStatus === 'rejected') return 'rejected';
    if (appStatus === 'eligibility') return 'under_review';
    if (appStatus === 'under_review') return 'under_review';
    return 'received';
  };

  const docStatus = getDocStatus();

  const documents = [
    {
      label: 'Identity Document',
      sublabel: application?.document_type ? `${application?.document_type?.replace(/_/g, ' ')}` : 'ID Document',
      hasFile: !!application?.document_front_url,
      icon: 'IdCard',
    },
    {
      label: 'Document Back',
      sublabel: 'Reverse side',
      hasFile: !!application?.document_back_url,
      icon: 'FileImage',
    },
    {
      label: 'Selfie / Liveness',
      sublabel: 'Identity verification photo',
      hasFile: !!application?.selfie_url,
      icon: 'Camera',
    },
  ]?.filter((d) => d?.hasFile);

  if (!documents?.length) return null;

  const statusInfo = DOC_STATUS?.[docStatus];

  return (
    <div
      className="rounded-2xl p-6"
      style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)' }}
    >
      <div className="flex items-center gap-2 mb-5">
        <div
          className="w-7 h-7 rounded-lg flex items-center justify-center"
          style={{ background: 'linear-gradient(135deg,#0d9488,#1d4ed8)' }}
        >
          <Icon name="Files" size={13} color="#fff" />
        </div>
        <h2 className="text-sm font-semibold text-white" style={{ fontFamily: 'DM Sans, sans-serif' }}>Document Status</h2>
      </div>
      <div className="space-y-2">
        {documents?.map((doc, i) => (
          <div
            key={i}
            className="flex items-center gap-3 p-3 rounded-xl"
            style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.06)' }}
          >
            <div
              className="w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0"
              style={{ background: 'rgba(255,255,255,0.06)' }}
            >
              <Icon name={doc?.icon} size={15} color="rgba(255,255,255,0.5)" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium" style={{ color: 'rgba(255,255,255,0.8)', fontFamily: 'DM Sans, sans-serif' }}>{doc?.label}</p>
              <p className="text-xs capitalize" style={{ color: 'rgba(255,255,255,0.35)' }}>{doc?.sublabel}</p>
            </div>
            <div
              className="flex items-center gap-1.5 px-2.5 py-1 rounded-full flex-shrink-0"
              style={{ background: statusInfo?.bg, border: `1px solid ${statusInfo?.border}` }}
            >
              <Icon name={statusInfo?.icon} size={11} color={statusInfo?.color} />
              <span style={{ fontSize: '11px', color: statusInfo?.color, fontWeight: 600 }}>{statusInfo?.label}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DocumentStatusIndicators;
